/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

import { ILoyaltyBalanceCheckData } from './loyalty-balance-check.data';
import { ILoyaltyBalanceCheckProps } from './loyalty-balance-check.props.autogenerated';

export interface ILoyaltyBalanceCheckViewProps extends ILoyaltyBalanceCheckProps<ILoyaltyBalanceCheckData> {}

/**
 *
 * LoyaltyBalanceCheck component
 * @extends {React.PureComponent<ILoyaltyBalanceCheckProps<ILoyaltyBalanceCheckData>>}
 */
class LoyaltyBalanceCheck extends React.PureComponent<ILoyaltyBalanceCheckProps<ILoyaltyBalanceCheckData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default LoyaltyBalanceCheck;
